import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface CTAButtonProps {
  onClick: () => void;
  variant?: "primary" | "secondary";
  mobileText?: React.ReactNode;
  desktopText: string;
  className?: string;
}

export const CTAButton = ({
  onClick,
  variant = "primary",
  mobileText,
  desktopText,
  className,
}: CTAButtonProps) => {
  const baseStyles = "text-white px-4 sm:px-8 py-6 text-sm sm:text-lg rounded-full transition-all duration-300 hover:scale-105 w-full sm:w-auto";
  const variantStyles = variant === "primary" 
    ? "bg-primary hover:bg-primary/90" 
    : "bg-secondary hover:bg-secondary/90";

  return (
    <Button
      size="lg"
      className={cn(
        baseStyles,
        variantStyles,
        mobileText && "min-h-[5rem] sm:min-h-0",
        className
      )}
      onClick={onClick}
    >
      {mobileText ? (
        <>
          <span className="block sm:hidden">{mobileText}</span>
          <span className="hidden sm:block">{desktopText}</span>
        </>
      ) : (
        desktopText
      )}
    </Button>
  );
};